<template>
<div>
    <div>
        <label
            class="btn btn-secondary w-100 d-flex"
            :for="id_computed"
        >
            <svg-image
                class="col-4"
                svg_name="camera"
                color="primary"
            />

            <div class="col-4 text-center">{{ label_computed }}</div>
        </label>
        <input
            :id="id_computed"
            :required="required"
            :name="id_computed"
            @change="addImages"
            type="file"
            accept="image/*"
            multiple="multiple"
            hidden
        />
    </div>

    <div
        v-if="image_previews && image_previews.length"
        class="row"
    >
        <div
            v-for="(image_url, index) in image_previews"
            class="col-xs-12 col-md-4 mb-3"
        >
            <img
                class="w-100 rounded"
                :id="`output-${index}`"
                :src="image_url"
            />
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'FormQuestionImage',
    props: {
        id: {
            type: String,
            required: false,
        },
        question: {
            type: Object,
            required: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        request_form: {
            type: Object,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            image_previews: [],
        };
    },
    computed: {
        id_computed() {
            return this.id ?? this.question.local_id + '.image';
        },
        image_previews_computed() {
            return this.request_form[this.id_computed] ?? {};
        },
        label_computed() {
            return this.label ?? `Add Photo ${this.required ? '(required)' : '(optional)'}`;
        }
    },
    methods: {
        addImagePreview(image) {
            this.image_previews.push(URL.createObjectURL(image));
        },
        addImages(event) {
            if (event?.target?.files?.length === 0) {
                return;
            }

            Array.from(event.target.files).forEach((image) => {
                this.updateValue(image);
            });
        },
        updateValue(image) {
            if (!image) {
                return;
            }

            const reader = new FileReader();

            reader.onload = (e) => {
                this.$emit('update-value', this.id_computed, image);
                this.addImagePreview(image);
            };

            reader.readAsDataURL(image);
        },
    },
};
</script>
